function updateActiveItem(newActiveItem) {
  document.querySelectorAll(".rbsv4-inner-toggle-card__toggle-item").forEach((item) => {
    item.classList.toggle("active", item === newActiveItem);
  });
}

function handleMobileToggle(event) {
  const newActiveItem = event.target.closest(".rbsv4-inner-toggle-card__toggle-item");
  if (!newActiveItem) return;

  const siblings = Array.from(newActiveItem.parentElement.children);
  const newActiveIndex = siblings.indexOf(newActiveItem);

  updateActiveItem(newActiveItem);
  document.querySelectorAll(".rbsv4-inner-toggle-card__toggle-item-description.mobile").forEach((desc, i) => {
    desc.classList.toggle("active", i === newActiveIndex);
  });
}

function initializeMobileToggleItemHandlers() {
  const toggleItems = document.querySelectorAll(".rbsv4-inner-toggle-card__toggle-item");
  if (toggleItems.length === 0) return;
  toggleItems.forEach((item) => item.addEventListener("click", handleMobileToggle));
}

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 990) {
    initializeMobileToggleItemHandlers();
  }
});
